var r=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(r,t){return r.__proto__=t,r}:function(r,t){for(var o in t)Object.prototype.hasOwnProperty.call(r,o)||(r[o]=t[o]);return r});export{r as setPrototypeOf};
